/* eslint-disable enforce-catch-error-handled/require-catch-error-handling */
// TODO: Remove this eslint-disable comment in a separate PR (RCP-27576)
import {
  useDynamicDocumentTitle,
  useLocale,
  useRoutesMonitoring,
} from '@issuemanager/apps/client/hooks';
import { WithTheme } from '@issuemanager/apps/client/theme';
import { styled } from '@mui/material';
import { Container, ContainerProps } from '@mui/system';
import { useEffect, useState, type JSX, type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingProgress } from './LoadingProgress';
import { AppHeader } from './app-header';

const StyledContainer = styled(Container)<WithTheme<ContainerProps>>(
  ({ theme }) => ({
    minHeight: `calc(100vh - ${theme.spacing(8)})`,
    backgroundColor: theme.tokens.semantic.color.background.base.value,
    display: 'flex',
    flexDirection: 'column',
  }),
);

export default function Layout({ children }: PropsWithChildren): JSX.Element {
  const { i18n } = useTranslation();
  const locale = useLocale();
  const [isLanguageReady, setIsLanguageReady] = useState(false);

  useRoutesMonitoring();
  useDynamicDocumentTitle();

  useEffect(() => {
    const handleLanguageChange = async (newLocale: string): Promise<void> => {
      try {
        // Set i18n locale globally
        await i18n.changeLanguage(newLocale);
        setIsLanguageReady(true);
      } catch (error) {
        // Log error and set ready state to prevent infinite loading
        // eslint-disable-next-line no-console
        console.error('Failed to change language:', error);
        setIsLanguageReady(true);
      }
    };

    handleLanguageChange(locale);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <StyledContainer disableGutters maxWidth={false}>
      {!isLanguageReady ? (
        <LoadingProgress flex={1} />
      ) : (
        <>
          <AppHeader />
          {children}
        </>
      )}
    </StyledContainer>
  );
}
